import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { marketingAPI } from '../utils/api';
import { storeMarketingAttribution } from '../utils/marketingAttribution';

const shouldTrackVisit = (params) => {
  const source = params.get('utm_source');
  const medium = params.get('utm_medium');
  const campaign = params.get('utm_campaign');
  return Boolean(campaign) || source === 'marketing' || medium === 'email';
};

const MarketingVisitTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!shouldTrackVisit(params)) return;

    const utmCampaign = params.get('utm_campaign');
    const key = `mkt_visit_${utmCampaign || 'unknown'}_${location.pathname}_${location.search}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, '1');

    const attributionPayload = {
      utmCampaign: utmCampaign,
      utmSource: params.get('utm_source'),
      utmMedium: params.get('utm_medium'),
      utmContent: params.get('utm_content'),
      utmTerm: params.get('utm_term'),
      landingPath: location.pathname,
      landingUrl: window.location.href,
      referrer: document.referrer || ''
    };

    marketingAPI.trackVisit({
      utm_campaign: utmCampaign,
      utm_source: params.get('utm_source'),
      utm_medium: params.get('utm_medium'),
      utm_content: params.get('utm_content'),
      utm_term: params.get('utm_term'),
      path: location.pathname,
      url: window.location.href,
      referrer: document.referrer || ''
    }).then((data) => {
      storeMarketingAttribution({
        ...attributionPayload,
        visitId: data?.id
      });
    }).catch(() => {
      storeMarketingAttribution(attributionPayload);
    });
  }, [location.pathname, location.search]);

  return null;
};

export default MarketingVisitTracker;
